export default __webpack_public_path__ + "static/media/5-Sevan-Hvor og når føler du deg mest fremmed.bbdda737.mp4";